import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  title: {
    paddingLeft: 16,
  },
  text: {
    color: '#888888',
    textAlign: 'left',
    position: 'relative',
    padding: '0 18px',
  },
});

export default makeStyles(styles);
